import React from "react";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { IconButton } from "@material-ui/core";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";

export const BRISI_OCENU = gql`
  mutation brisiOcenu($_id: ID) {
    brisiOcenu(_id: $_id) {
      _id
    }
  }
`;

type PropTypes = {
  id: string;
};

export default function BrisiOcenu(props: PropTypes) {
  const [brisiOcenu] = useMutation(BRISI_OCENU);

  return (
    <IconButton
      onClick={() => {
        brisiOcenu({
          variables: { _id: props.id },
          refetchQueries: ["ucitajOcene"],
        });
      }}
    >
      <DeleteForeverIcon />
    </IconButton>
  );
}
